import { render } from "./LandingPageBLG.vue?vue&type=template&id=0c31afbe&scoped=true"
import script from "./LandingPageBLG.vue?vue&type=script&lang=js"
export * from "./LandingPageBLG.vue?vue&type=script&lang=js"

import "./LandingPageBLG.vue?vue&type=style&index=0&id=0c31afbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c31afbe"]])

export default __exports__